import React from 'react'
import PropTypes from 'prop-types'

import { languageController } from '../../../controllers/language/languageController'

import DateAndTimeSelector from '../../3_Organisms/DateAndTimeSelector/DateAndTimeSelector'

function DateAndTimeStep({
  handleNextStep,
  title,
  subTitle,
  isService,
  handlePreviousStep
}) {
  return (
    <div className="mz-date-and-time-step">
      <div className="mz-date-and-time-step__top">
        <div className="mz-container">
          <div className="mz-full-width">
            <h5 className="mz-date-and-time-step__title">{title}</h5>
            <p>{subTitle}</p>
            {isService && <p>{languageController.getCopy('bookServiceAppointment', 'notice')}</p>}
          </div>
        </div>
      </div>
      <DateAndTimeSelector onSubmit={(data) => handleNextStep({ dateAndTime: data })} isService={isService} onGoBack={() => handlePreviousStep()}/>
    </div>
  )
}

DateAndTimeStep.propTypes = {
  handleNextStep: PropTypes.func.isRequired,
  title: PropTypes.string,
  subTitle: PropTypes.string,
}

export default DateAndTimeStep